'use strict';
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";

let MutexService = {


    Lock(mutexId,delay) {
        let mutexOject;
        let mutexKey;
        let requestKey;
        let requestObject;
        let resolveHandler = null;
        let resultPromise = new Promise(
            (resolve) => {
                resolveHandler = resolve;
            }
        );
        let isNew = false;


        if (delay == null) {
            delay = 1;
        }

        if (window[mutexId] == null) {
            window[mutexId] = {
                Processing: false,
                RequestSet: {},
                ProcessRequest: null,
                Delay :delay,
            };

            window[mutexId].ProcessRequest = this.ProcessRequest.bind(this, mutexId);
            isNew = true;

            //console.log("mutexId=" + mutexId + " !")
        }


        mutexOject = window[mutexId];


        requestKey = this.CreateMutexKey(mutexId);

        requestObject = {
            Key: requestKey,
            ResultPromise: resultPromise,
            ResolveHandler: (r, index) => {
                resolveHandler(r);
            }
        };


        mutexOject.RequestSet[requestKey] = requestObject;

        if (mutexOject.Processing == false) {
            window[mutexId].Processing = true;
            window[mutexId].ProcessRequest(mutexId);
        }

        return resultPromise;
    },//end Lock(mutexId) {


    index: 0,

    ProcessRequest(mutexId) {
        let mutexObject;



        if ((mutexObject = window[mutexId]) != null) {
            mutexObject.Processing = true;

            //console.log("ProcessRequest");
 
            if (Object.keys(mutexObject.RequestSet).length > 0) {
                let resultHandler;
                let delay;
                let resultPromise = new Promise((r) => {
                    resultHandler = r;
                });
                let requestObject;
                let key;


                mutexObject.LastIdleTime = null;

                delay = mutexObject.Delay;

                key = Object.keys(mutexObject.RequestSet)[0]

                requestObject = mutexObject.RequestSet[key];

                this.index++;

                requestObject.ResolveHandler(resultHandler, this.index);

                resultPromise.then(
                    (result) => {
                        delete mutexObject.RequestSet[key];

                        setTimeout(
                            () => {
                                this.ProcessRequest(mutexId);
                            },
                            delay
                        );
                    }
                );
            }
            else {
                let currDate = new Date();

                console.log("Mutex Block");

                if (mutexObject.LastIdleTime == null) {
                    mutexObject.LastIdleTime = new Date();
                }

                if (currDate - mutexObject.LastIdleTime > 20000) {
                    mutexObject.Processing = false;

                    //console.log("[" + mutexId + "]: Stop Processing");
                }
                else if (currDate - mutexObject.LastIdleTime < 5000) {
                    //console.log("delay 300");
                    setTimeout(
                        () => {
                            this.ProcessRequest(mutexId);
                        },
                        300
                    );
                }
                else {
                    //console.log("delay 1000");
                    setTimeout(
                        () => {
                            this.ProcessRequest(mutexId);
                        },
                        1000
                    );
                }
            }
        }//end if ((mutexObject = window[mutexId]) != null) {
    },//end ProcessRequest(mutexId) {



    CreateMutexKey(mutexId) {
        let mutexKey;
        let date;

        date = new Date();

        mutexKey = mutexId + "_" + date.getTime() + "_" +
            Math.floor(Math.random() * 1000000);


        return mutexKey;
    },

}//end let MutexService = {


export default MutexService;

